import Modal from "react-modal";
import React, { useState, memo } from "react";
import { format } from "date-fns";
import Swal from "sweetalert2";

// COMPONENTS
import ItemCard from "./ItemCard";
import LoadingPage from "../Loading/LoadingPage";

// HOOKS
import useGiftRecommend from "../../hooks/useGiftRecommend";

// AWS
import { S3Image } from "aws-amplify-react";
import { API, Auth, Storage } from "aws-amplify";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)

function GiftRecommend({
  prop,
  isEdit,
  setIsEdit,
  modalItem,
  setModalItem,
  closeModal,
}) {
  const { datas, loading, error, getData } = useGiftRecommend();

  const [modalIsOpen, setIsOpen] = useState(false);

  function openModal(item) {
    setIsOpen(true);
    setModalItem(item);
  }

  function closeModal() {
    setIsOpen(false);
    setModalItem(null);
  }

  const onDelete = async () => {
    try {
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะลบสินค้านี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          await API.del("MoneyHubAdmin", `/gift/${modalItem.shop_id}`, {
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        },
      });
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "ลบสินค้าสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      setIsOpen(false);
      closeModal();
      setModalItem(null);
      await getData();
    } catch (error) {
      console.log("Error", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  const Term = memo(({ raw_term }) => {
    const term = raw_term.split("|");
    return (
      <div className="m-2">
        {term.map((item, index) => {
          return (
            <div className="text-gray-700 font-medium text-base">{item}</div>
          );
        })}
      </div>
    );
  });

  if (loading) {
    return <LoadingPage />;
  }
  if (error) {
    return <p>Error...</p>;
  }

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4 mx-8">
        {datas.map((item, index) => {
          return <ItemCard item={item} key={index} openModal={openModal} />;
        })}
      </div>
      <Modal
        isOpen={modalIsOpen}
        //  onAfterOpen={afterOpenModal}
        // onAfterClose={() => setModalItem(null)}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        {modalItem ? (
          <React.Fragment>
            <div className="max-w-3xl h-600-px 2xl:h-650-px  3xl:h-850-px">
              <div className="grid grid-cols-3 gap-1">
                {modalItem.img.map((img, index) => {
                  return (
                    <S3Image
                      imgKey={img}
                      className="w-60 h-60 object-contain bg-gray-100"
                    />
                  );
                })}
              </div>
              <div className="flex flex-row justify-between">
                <div className="m-2  text-gray-700 font-bold text-base">
                  {modalItem.name}
                </div>
                <div className="m-2  text-gray-400 font-medium text-base">
                  อัพเดทเมื่อ{" "}
                  {format(new Date(modalItem.timestamp), "dd/MM/yyyy")}
                </div>
              </div>

              <div className="flex flex-row justify-between">
                <div className="m-2  text-blue-500 font-medium text-base">
                  {modalItem.category}
                </div>
                <div
                  className={
                    "m-2  " +
                    (modalItem.is_recommend
                      ? "text-green-400"
                      : "text-gray-400") +
                    " font-medium text-base"
                  }
                >
                  {modalItem.is_recommend
                    ? "เป็นสินค้ายอดนิยม"
                    : "ไม่เป็นสินค้ายอดนิยม"}
                </div>
              </div>
              <hr></hr>
              <div className="m-2  text-gray-700 font-bold text-base">
                คำอธิบาย
              </div>
              <div className="m-2  text-gray-700 font-medium text-base">
                {modalItem.desc}
              </div>
              <hr></hr>
              <div className="m-2  text-gray-700 font-bold text-base">
                เงื่อนไข
              </div>
              <Term raw_term={modalItem.term} />
              <hr></hr>
              <div className="m-2  text-blue-500 font-medium text-base">
                ใช้ {modalItem.price} คะแนนในการแลก
              </div>
              <button
                onClick={onDelete}
                className="bg-red-500 p-2 text-white w-full"
              >
                ลบสินค้า
              </button>
              <button
                onClick={() => setIsEdit(true)}
                className=" p-2 text-blue-500 w-full"
              >
                แก้ไขสินค้า
              </button>
            </div>
          </React.Fragment>
        ) : null}
      </Modal>
    </div>
  );
}

export default GiftRecommend;
